import React, { useState } from 'react';
import Select from 'react-select';
import { Table } from 'antd';

const ShippingDtlsTab = () => {
const [disableHawbIssuedBy, setDisableHawbIssuedBy] = useState(true);

// Placeholder options (replace these with actual data)
const joborderOptions = [];
const agentOptions = [];
const customerOptions = [];
const quotationOptions = [];
const columns = [
    { title: "Ref No.", dataIndex: "SNo", key: "SNo" },
    { title: "Ref Date", dataIndex: "Name", key: "Name" },
    { title: "Type", dataIndex: "Alias", key: "Alias" },
    { title: "Trans. No.", dataIndex: "NVOCC", key: "NVOCC" },
    { title: "Trans. Date", dataIndex: "HomepageURL", key: "HomepageURL" },
    { title: "Amount	", dataIndex: "HomepageURL", key: "HomepageURL" },
    { title: "Advance", dataIndex: "HomepageURL", key: "HomepageURL" },
];

const dataSource = [
    {
        key: "1",
    }
];

return (
<>
<form>
        <div className="card">
            <div className="card-body">
            <div className="table-responsive custom-table">
                                <Table className="table datanew dataTable no-footer" pagination={false}
                                    dataSource={dataSource} columns={columns} />
                            </div>
            </div>
        </div>
    </form>
</>
)
}

export default ShippingDtlsTab